import memoize, { type CacheItem } from "@-/com.npmjs.memoize";

/** Several phone viewports, independent of how far through a catalog Leon scrolls. */
export const TILE_SLICE_CACHE_LIMIT = 512;

/** Mounted tiles keep their own references; cache eviction never mutates their slices. */
export function createTileSliceCache<Value>(
  resolve: (key: string) => Value,
): (key: string) => Value {
  const entries = new Map<string, CacheItem<Value>>();
  return memoize(resolve, {
    cache: {
      clear: () => entries.clear(),
      delete: (key: string) => {
        entries.delete(key);
      },
      get: (key: string) => {
        const value = entries.get(key);
        if (value !== undefined) {
          entries.delete(key);
          entries.set(key, value);
        }
        return value;
      },
      set: (key: string, value: CacheItem<Value>) => {
        entries.delete(key);
        if (entries.size >= TILE_SLICE_CACHE_LIMIT) {
          const oldest = entries.keys().next().value;
          if (oldest !== undefined) {
            entries.delete(oldest);
          }
        }
        entries.set(key, value);
      },
    },
  });
}
